import { combineReducers } from 'redux';
import {
  findIfAnyPlanActive,
  findIfAnyPlanUpcoming,
} from '../helpers/subscription';
import users from './users';
import algos from './algos';
import algosTypes from './algos-types';
import live from './live';
import algosLive from './algos-live';
import brokers from './brokers';
import notifications from './notifications';
import positions from './positions';
import status from './status';
import connection from './connection';
import monitors from './monitors';
import healthStatus from './health-status';
import masterContracts from './master-contracts';
import algosConfig from './algos-config';
import referrals from './referrals';
import credits from './credits';
import subscription from './subscription';
import expiryNotification from './expiry-notification';
import theme from './theme';
import announcements from '../stores/announcements/reducers';
import algosList from '../stores/algos-list/reducers';
import algoEditConfig from '../stores/algo-edit-config/reducers';
import algoLive from '../stores/algo-live/reducers';
import sidebar from '../stores/sidebar/reducers';
import reports from '../stores/reports/reducers';
import underlyingLiveFeed from '../stores/underlying-live-feed/reducers';
import createAlgo from '../stores/create-algo/reducers';
import localSettings from '../stores/local-settings/reducers';
import brokerSetupScreen from '../stores/broker-setup-screen/reducers';
import brokerLoginScreen from '../stores/broker-login-screen/reducers';
import botNotifications from '../stores/bot-notifications/reducers';
import noticeboard from '../stores/noticeboard/reducers';
import algosListStats from '../stores/algos-list-stats/reducers';
import customSignup from '../stores/custom-signup/reducers';
import algosListTableSettings from '../stores/algos-list-table-settings/reducers';
import symbolLiveFeed from '../stores/symbol-live-feed/reducers';
import algoLiveStats from '../stores/algo-live-stats/reducers';
import pnlChart from '../stores/pnl-chart/reducers';
import chartStore from '../stores/chart-store/reducers';
import brokerLoginUrls from '../stores/broker-login-urls/reducers';
import algoListSavedConfig from '../stores/algo-list-saved-config/reducers';
import miscModals from '../stores/misc-modals/reducers';
import signals from '../stores/signals-main/signals/reducers';
import createSignal from '../stores/signals-main/create-signal/reducers';
import editSignal from '../stores/signals-main/edit-signal/reducers';
import signalGroupAlgoList from '../stores/signals-main/edit-signal/signal-group/algo-list/reducers';
import signalAlerts from '../stores/signals-main/alert/reducers';
import userOrderBook from '../stores/user-order-book/reducers';
import notificationAlerts from '../stores/notification-alerts/reducers';
import userMargin from '../stores/user-margin/reducers';
import algoBulkErrors from '../stores/algo-bulk-errors/reducers';

const rootReducer = combineReducers({
  users,
  algosConfig,
  live,
  algosLive,
  brokers,
  notifications,
  algosTypes,
  positions,
  status,
  connection,
  monitors,
  healthStatus,
  masterContracts,
  referrals,
  credits,
  subscription,
  expiryNotification,
  theme,
  algosList,
  algos,
  algoEditConfig,
  algoLive,
  sidebar,
  reports,
  underlyingLiveFeed,
  createAlgo,
  localSettings,
  brokerSetupScreen,
  brokerLoginScreen,
  announcements,
  botNotifications,
  noticeboard,
  algosListStats,
  customSignup,
  algosListTableSettings,
  symbolLiveFeed,
  algoLiveStats,
  pnlChart,
  chartStore,
  brokerLoginUrls,
  algoListSavedConfig,
  miscModals,
  signals,
  createSignal,
  editSignal,
  signalGroupAlgoList,
  signalAlerts,
  userOrderBook,
  notificationAlerts,
  userMargin,
  algoBulkErrors,
});

export default rootReducer;

// selected Backtest
export const getIsSelectedBacktestFetching = (state) =>
  state.backtests.selected.isFetching;

export const getIsSelectedBacktestErrorMessage = (state) =>
  state.backtests.selected.errorMessage;

export const getIsSelectedBacktest = (state) => state.backtests.selected.data;

export const getIsSelectedBacktestOk = (state) =>
  state.backtests.selected.data && state.backtests.selected.data.name
    ? true
    : false;

// backtests list
export const getIsBacktestsFetching = (state) =>
  state.backtests.list.isFetching;

export const getIsBacktestsErrorMessage = (state) =>
  state.backtests.list.errorMessage;

export const getIsBacktests = (state) => state.backtests.list.data.data;

// selected User
export const getIsSelectedUserFetching = (state) =>
  state.users.selected.isFetching;

export const getIsSelectedUserErrorMessage = (state) =>
  state.users.selected.errorMessage;

export const getIsSelectedUserErrors = (state) => state.users.selected.errors;

export const getIsSelectedUser = (state) => state.users.selected.data;

export const getIsSelectedUserConfig = (state) =>
  state.users.selected.data && state.users.selected.data.configurations
    ? state.users.selected.data.configurations
    : {};

export const getIsSelectedUserOk = (state) =>
  state.users.selected.data && state.users.selected.data._id ? true : false;

// selected result
export const getIsSelectedBacktestResultFetching = (state) =>
  state.results.selected.isFetching;

export const getIsSelectedBacktestResultErrorMessage = (state) =>
  state.results.selected.errorMessage;

export const getIsSelectedBacktestResult = (state) =>
  state.results.selected.data;

export const getIsSelectedBacktestResultResultData = (state) =>
  state.results.selected &&
  state.results.selected.data &&
  state.results.selected.data.data &&
  state.results.selected.data.data.length
    ? state.results.selected.data.data.filter((d) => d)
    : [];

export const getIsSelectedBacktestResultConfig = (state) =>
  state.results.selected.data.configurations;

export const getIsSelectedBacktestResultOk = (state) =>
  state.results.selected.data &&
  state.results.selected.data.status &&
  state.results.selected.data.status === 'success'
    ? true
    : false;

// selected Algo
export const getIsSelectedAlgoFetching = (state) =>
  state.algos.selected.isFetching;

export const getIsSelectedAlgoErrorMessage = (state) =>
  state.algos.selected.errorMessage;

export const getIsSelectedAlgo = (state) =>
  state.algos.selected.data && state.algos.selected.data.data
    ? state.algos.selected.data.data
    : {};

export const getIsSelectedAlgoOk = (state) =>
  state.algos.selected.data &&
  state.algos.selected.data.status &&
  state.algos.selected.data.status === 'success'
    ? true
    : false;

export const getIsSelectedAlgoStatus = (state) =>
  state.algos.selected.data &&
  state.algos.selected.data.data &&
  state.algos.selected.data.data.status
    ? state.algos.selected.data.data.status
    : '';

// Algos list
export const getIsAlgosFetching = (state) => state.algos.list.isFetching;

export const getIsAlgosErrorMessage = (state) => state.algos.list.errorMessage;

export const getIsAlgos = (state) =>
  state.algos.list.data.data ? state.algos.list.data.data : [];

export const getIsAlgosOk = (state) =>
  state.algos.list.data &&
  state.algos.list.data.status &&
  state.algos.list.data.status === 'success'
    ? true
    : false;

export const getIsAlgosTypesFetching = (state) =>
  state.algosTypes.list.isFetching;

export const getIsAlgosTypesErrorMessage = (state) =>
  state.algosTypes.list.errorMessage;

export const getIsAlgosTypes = (state) =>
  state.algosTypes.list.data.data ? state.algosTypes.list.data.data : [];

export const getIsAlgosDayWiseFetching = (state) =>
  state.algosDayWise.list.isFetching;

export const getIsAlgosDayWiseErrorMessage = (state) =>
  state.algosDayWise.list.errorMessage;

export const getIsAlgosDayWise = (state) =>
  state.algosDayWise.list.data.data ? state.algosDayWise.list.data.data : [];

export const getIsAlgosDayWiseOk = (state) =>
  state.algosDayWise.list.data &&
  state.algosDayWise.list.data.status &&
  state.algosDayWise.list.data.status === 'success'
    ? true
    : false;

// live
// export const getIsLiveFetching = state => state.live.selected.isFetching;

export const getLiveOrderAPIStatus = () => 'NOT_RUNNING';
export const getLiveLiveFeedStatus = () => 'RUNNING';
export const getLiveAlgoStatus = () => 'NOT_RUNNING';

// selected Algo
export const getIsSelectedAlgoLiveFetching = (state) =>
  state.algosLive.selected.isFetching;

export const getIsSelectedAlgoLiveErrorMessage = (state) =>
  state.algosLive.selected.errorMessage;

export const getIsSelectedAlgoLive = (state) => state.algosLive.selected.data;

// Algos list
export const getIsAlgosLiveFetching = (state) =>
  state.algosLive.list.isFetching;

export const getIsAlgosLiveErrorMessage = (state) =>
  state.algosLive.list.errorMessage;

export const getIsAlgosLive = (state) =>
  state.algosLive.list.data.data ? state.algosLive.list.data.data : [];

// selected broker
export const getIsSelectedBrokerFetching = (state) =>
  state.brokers.selected.isFetching;

export const getIsSelectedBrokerErrorMessage = (state) =>
  state.brokers.selected.errorMessage;

export const getIsSelectedBroker = (state) => state.brokers.selected.data;

export const getIsSelectedBrokerOk = (state) =>
  state.brokers.selected.data && state.brokers.selected.data.name
    ? true
    : false;

// brokers list
export const getIsBrokersFetching = (state) => state.brokers.list.isFetching;

export const getIsBrokersErrorMessage = (state) =>
  state.brokers.list.errorMessage;

export const getIsBrokers = (state) =>
  state.brokers.list.data.data ? state.brokers.list.data.data : [];

export const getIsBrokersOk = (state) =>
  state.brokers.list.data.status &&
  state.brokers.list.data.status &&
  state.brokers.list.data.status === 'success'
    ? true
    : false;

// export const getBrokersDataAll = (state) => {
//   const brokersDataAll = getIsBrokers(state);
//   const formatSetupBrokerlabel = ({ brokerInfo = {}, clientId = '' }) => {
//     let { displayName = '', name: brokerName = '' } = brokerInfo;

//     if (brokerName === 'angel') {
//       displayName = 'Angel';
//     }

//     return `${clientId} - ${displayName}`;
//   };

//   const brokersDataAllFilterd = brokersDataAll.map((b) => ({
//     label: 'yo',
//     value: b.id,
//     brokerDisabled: b.status && b.status === 'disabled' ? true : false,
//   }));

//   return brokersDataAllFilterd;
// };

// brokers dir
export const getIsBrokersListFetching = (state) => state.brokers.dir.isFetching;

export const getIsBrokersListErrorMessage = (state) =>
  state.brokers.dir.errorMessage;

export const getIsBrokersList = (state) =>
  state.brokers.dir.data.data ? state.brokers.dir.data.data : [];

export const getIsBrokersListOk = (state) =>
  state.brokers.dir.data.status &&
  state.brokers.dir.data.status &&
  state.brokers.dir.data.status === 'success'
    ? true
    : false;

// Notifications list
export const getIsNotifications = (state) => state.notifications.list.data;
export const getIsNotificationsTry = (state) => state.notifications.list;

// live feed
export const getIsLiveFeed = (state) => state.status.liveFeed;

// status
export const getIsAlgoStatusFetching = (state) =>
  state.status.selected.isFetching;

export const getIsAlgoStatusErrorMessage = (state) =>
  state.status.selected.errorMessage;

export const getIsAlgoStatusAlgo = (state) =>
  state.status.selected.data && state.status.selected.data.data
    ? state.status.selected.data.data
    : {};

// get live positions
export const getLivePositions = (state) =>
  state.positions.data ? state.positions.data : {};

// get connection status
export const getConnectionStatus = (state) =>
  state.connection && state.connection.status ? state.connection.status : '';

export const getConnectionTimestamp = (state) =>
  state.connection && state.connection.timestamp
    ? state.connection.timestamp
    : '';

// monitors
export const getMonitors = (state) =>
  state.monitors && state.monitors.data ? state.monitors.data : {};

// healthStatus
export const getHealthStatusData = (state) =>
  state.healthStatus && state.healthStatus.data ? state.healthStatus.data : {};

// Master contracts
export const getIsMasterContractsFetching = (state) =>
  state.masterContracts.list.isFetching;

export const getIsMasterContracts = (state) => state.masterContracts.list.data;

export const getIsMasterContractsCheckDone = (state) =>
  state.masterContracts.list.checkDone || false;

// Algos config
export const getIsAlgosConfigFetching = (state) => state.algosConfig.isFetching;

export const getIsAlgosConfigErrorMessage = (state) =>
  state.algosConfig.errorMessage;

export const getIsAlgosConfig = (state) =>
  state.algosConfig.data.data ? state.algosConfig.data.data : {};

export const getIsAlgosConfigOk = (state) =>
  state.algosConfig.data &&
  state.algosConfig.data.status &&
  state.algosConfig.data.status === 'success'
    ? true
    : false;

// selected User
export const getIsMyReferralsFetching = (state) =>
  state.referrals.selected.isFetching;

export const getIsMyReferralsErrorMessage = (state) =>
  state.referrals.selected.errorMessage;

export const getIsMyReferrals = (state) => state.referrals.selected.data;

export const getIsMyReferralsPaging = (state) =>
  state.referrals.selected.paging;

// credits
export const getIsCreditsFetching = (state) => state.credits.isFetching;

export const getCreditsErrorMessage = (state) => state.credits.errorMessage;

export const getCredits = (state) => state.credits.data;

export const getCreditsPaging = (state) => state.credits.data.paging;

export const getIsCreditsOk = (state) =>
  state.credits.data.status &&
  state.credits.data.status &&
  state.credits.data.status === 'success'
    ? true
    : false;

// subscription plans
export const getIsSubscriptionPlansFetching = (state) =>
  state.subscription.plans.isFetching;

export const getIsSubscriptionPlansErrorMessage = (state) =>
  state.subscription.plans.errorMessage;

export const getSubscriptionPlans = (state) =>
  state.subscription.plans.data.data ? state.subscription.plans.data.data : [];

export const getIsSubscriptionPlansCreditsOk = (state) =>
  state.subscription.plans.data.status &&
  state.subscription.plans.data.status &&
  state.subscription.plans.data.status === 'success'
    ? true
    : false;

// subscription coupons
export const getIsSubscriptionCouponsFetching = (state) =>
  state.subscription.coupons.isFetching;

export const getIsSubscriptionCouponsErrorMessage = (state) =>
  state.subscription.coupons.errorMessage;

export const getSubscriptionCoupons = (state) =>
  state.subscription.coupons.data.data
    ? state.subscription.coupons.data.data
    : [];

export const getIsSubscriptionCouponsCreditsOk = (state) =>
  state.subscription.coupons.data.status &&
  state.subscription.coupons.data.status &&
  state.subscription.coupons.data.status === 'success'
    ? true
    : false;

// Checkout preview
export const getIsCheckoutPreviewFetching = (state) =>
  state.subscription.checkoutPreview.isFetching;

export const getIsCheckoutPreviewErrorMessage = (state) =>
  state.subscription.checkoutPreview.errorMessage;

export const getCheckoutPreview = (state) =>
  state.subscription.checkoutPreview.data.data
    ? state.subscription.checkoutPreview.data.data
    : {};

export const getIsCheckoutPreviewOk = (state) =>
  state.subscription.checkoutPreview.data.status &&
  state.subscription.checkoutPreview.data.status &&
  state.subscription.checkoutPreview.data.status === 'success'
    ? true
    : false;

// Checkout Edit preview
export const getIsCheckoutEditPreviewFetching = (state) =>
  state.subscription.checkoutEditPreview.isFetching;

export const getIsCheckoutEditPreviewErrorMessage = (state) =>
  state.subscription.checkoutEditPreview.errorMessage;

export const getCheckoutEditPreview = (state) =>
  state.subscription.checkoutEditPreview.data.data
    ? state.subscription.checkoutEditPreview.data.data
    : {};

export const getIsCheckoutEditPreviewOk = (state) =>
  state.subscription.checkoutEditPreview.data.status &&
  state.subscription.checkoutEditPreview.data.status &&
  state.subscription.checkoutEditPreview.data.status === 'success'
    ? true
    : false;

// Checkout Edit preview only immediate
export const getIsCheckoutEditPreviewOnlyImmediateFetching = (state) =>
  state.subscription.checkoutEditPreviewOnlyImmediate.isFetching;

export const getIsCheckoutEditPreviewOnlyImmediateErrorMessage = (state) =>
  state.subscription.checkoutEditPreviewOnlyImmediate.errorMessage;

export const getCheckoutEditPreviewOnlyImmediate = (state) =>
  state.subscription.checkoutEditPreviewOnlyImmediate.data.data
    ? state.subscription.checkoutEditPreviewOnlyImmediate.data.data
    : {};

export const getIsCheckoutEditPreviewOnlyImmediateOk = (state) =>
  state.subscription.checkoutEditPreviewOnlyImmediate.data.status &&
  state.subscription.checkoutEditPreviewOnlyImmediate.data.status &&
  state.subscription.checkoutEditPreviewOnlyImmediate.data.status === 'success'
    ? true
    : false;

export const getIfAnyPlanActive = (state) => {
  const data = state.subscription.plans.data.data
    ? state.subscription.plans.data.data
    : [];

  return findIfAnyPlanActive(data);
};

export const getIfAnyPlanUpcoming = (state) => {
  const data = state.subscription.plans.data.data
    ? state.subscription.plans.data.data
    : [];

  return findIfAnyPlanUpcoming(data);
};

// algo day wise refresh
export const getIsAlgosDayWiseRefreshFetching = (state) =>
  state.algosDayWiseRefresh.list.isFetching;

export const getIsAlgosDayWiseRefreshErrorMessage = (state) =>
  state.algosDayWiseRefresh.list.errorMessage;

export const getIsAlgosDayWiseRefresh = (state) =>
  state.algosDayWiseRefresh.list.data.data
    ? state.algosDayWiseRefresh.list.data.data
    : [];

export const getIsAlgosDayWiseRefreshOk = (state) =>
  state.algosDayWiseRefresh.list.data &&
  state.algosDayWiseRefresh.list.data.status &&
  state.algosDayWiseRefresh.list.data.status === 'success'
    ? true
    : false;

export const getExpiryNotificationIsVisible = (state) =>
  state.expiryNotification.notificationIsOnScreen;

// healthStatus
export const getAlgosHealthStatusData = (state) =>
  state.algosHealthStatus && state.algosHealthStatus.data
    ? state.algosHealthStatus.data
    : {};

// theme
export const getIsDarkTheme = (state) => state.theme.isDark;
